import { render } from "./Choose.vue?vue&type=template&id=f58a4214&scoped=true"
import script from "./Choose.vue?vue&type=script&lang=js"
export * from "./Choose.vue?vue&type=script&lang=js"

import "./Choose.vue?vue&type=style&index=0&id=f58a4214&scoped=true&lang=css"

import exportComponent from "/home/andre_merino/aihuk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f58a4214"]])

export default __exports__